import {
  IGetIncompleteDeductionResolutionStatusParams,
  IIncompleteDeductionResolutionStatusRepositoryResponse,
  IRemittanceRepository,
} from "@/core/repositories/remittance";

export class GetIncompleteDeductionResolutionStatusUseCase {
  constructor(private readonly remittanceRepository: IRemittanceRepository) {}

  async execute(
    params: IGetIncompleteDeductionResolutionStatusParams,
    refetch: boolean = false
  ): Promise<IIncompleteDeductionResolutionStatusRepositoryResponse> {
    return this.remittanceRepository.getIncompleteDeductionResolutionStatus(params, refetch);
  }
}
